import { Pipe, PipeTransform } from '@angular/core';
import { InterventionStatus } from '../models/intervention';

const interventionStatusPipeText: { [key in InterventionStatus]: string } = {
  [InterventionStatus.COMPLETE]: 'Complete',
  [InterventionStatus.INCOMPLETE_NO_LONGER_APPLICABLE]: 'Incomplete - No Longer Applicable',
  [InterventionStatus.INCOMPLETE_PATIENT_REFUSAL]: 'Incomplete - Patient Refusal',
  [InterventionStatus.INPROGRESS]: 'In Progress'
};

@Pipe({
  name: 'interventionStatus'
})
export class InterventionStatusPipe implements PipeTransform {
  transform(value: InterventionStatus): string {
    return interventionStatusPipeText[value] || '';
  }
}
